import {darken, lighten, type Theme} from '@mui/material/styles'

const safeShiftPaper = (theme: Theme, lightAmt = 0.02, darkAmt = 0.08): string => {
  let base = theme.palette.background.paper
  const name = base?.toLowerCase?.()
  // Normalize named colors to hex so MUI color utils won’t crash
  if (name === 'white') {
    base = theme.palette.common.white
  }
  if (name === 'black') {
    base = theme.palette.common.black
  }

  return theme.palette.mode === 'light'
    ? darken(base, lightAmt) // slightly darker than paper in light mode
    : lighten(base, darkAmt) // slightly lighter than paper in dark mode
}

export {safeShiftPaper}
